module.exports = __webpack_public_path__ + "static/img/MTI-X7-Pro-B疼痛型.ddc868fd.jpg";